import queryClient from '../../../../../ReactQuery/client';
import useMutation from '../../../../../ReactQuery/useMutation';
import { remove } from '../../../../../redux/api';

const deleteRelease = (groupId: number, releaseId: number) =>
  remove(`/api/project_group/${groupId}/release/${releaseId}`);

// NOTE: This .toString() call is required in order to RQ to match
// keys since groupId is typed as a string in most other places.
const getQueryKey = (groupId: number) => ['releaseGroups', groupId.toString(), 'releases'];

/**
 * useDeleteRelease is a hook which provides the async callback
 * that allows us to delete a specific release group release.
 */
const useDeleteRelease = (groupId: number, releaseId: number) => {
  return useMutation({
    mutationFn: () => deleteRelease(groupId, releaseId),
    onSuccess: () => {
      // Refetch this group's releases after deleting one.
      queryClient.invalidateQueries(getQueryKey(groupId));
    },
  });
};

export default useDeleteRelease;
